if (!customElements.get('slider-component-navigation')) {
  class SliderComponentNavigation extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        prevBtn: '[btn-prev]',
        nextBtn: '[btn-next]',
      };
      this.init();
      this.updateNavStatus = this.debounce(this.updateNavStatus.bind(this), 200);
    }

    init() {
      this.sliderComponent = document.querySelector(`${this.dataset.id}`);

      if (!this.sliderComponent) return;

      this.sliderList = this.sliderComponent?.querySelector(`#Slider-${this.dataset.section}[data-id="${this.dataset.section}"]`);

      this.sliderBtnPrev = this.sliderComponent?.querySelector(`.slider-buttons [name="previous"]`);
      this.sliderBtnNext = this.sliderComponent?.querySelector(`.slider-buttons [name="next"]`);
      this.nextBtn = this.querySelector(this.selectors.nextBtn);
      this.prevBtn = this.querySelector(this.selectors.prevBtn);
      this.nextBtn?.addEventListener('click', this.onNextClick.bind(this));
      this.prevBtn?.addEventListener('click', this.onPrevClick.bind(this));
      this.sliderList?.addEventListener('scroll', () => {
        this.updateNavStatus();
      });
    }

    updateNavStatus() {
      this.prevBtn.disabled = this.sliderBtnPrev?.disabled || false;
      this.nextBtn.disabled = this.sliderBtnNext?.disabled || false;
    }

    onNextClick() {
      this.sliderBtnNext.click();
      this.updateNavStatus();
    }

    onPrevClick() {
      this.sliderBtnPrev.click();
      this.updateNavStatus();
    }

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }

  customElements.define('slider-component-navigation', SliderComponentNavigation);
}